/* unplugin-vue-components disabled */import { render } from "./PathChoicePop.vue?vue&type=template&id=0f0b1a86&scoped=true&ts=true"
import script from "./PathChoicePop.vue?vue&type=script&lang=ts"
export * from "./PathChoicePop.vue?vue&type=script&lang=ts"

import "./PathChoicePop.vue?vue&type=style&index=0&id=0f0b1a86&lang=scss&scoped=true"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0b1a86"]])

export default __exports__